var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _polygon, _path2, _polygon2, _polygon3, _path3, _polygon4, _path4, _path5, _path6, _path7, _path8, _polygon5, _path9, _polygon6, _path0, _path1, _path10, _polygon7, _path11, _path12, _path13, _path14, _polygon8, _path15, _polygon9, _path16, _circle3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditarperfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_13",
    "data-name": "Layer 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 647.06 566.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00479b;}.cls-2{fill:#d1d4d4;}.cls-3{fill:#dbf2fc;}.cls-27,.cls-4{fill:#9cc8ff;}.cls-26,.cls-5{fill:#006aea;}.cls-28,.cls-6{fill:none;}.cls-26,.cls-27,.cls-28,.cls-29,.cls-6{stroke:#00479b;}.cls-15,.cls-16,.cls-26,.cls-27,.cls-28,.cls-29,.cls-6{stroke-miterlimit:10;}.cls-7{fill:#deb87d;}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#radial-gradient);}.cls-15,.cls-16{stroke:#abd5ef;}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}.cls-26,.cls-27,.cls-28,.cls-29{stroke-width:11px;}.cls-29{fill:#24468b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -249.46,
    y1: 328.55,
    x2: -212.77,
    y2: 392.11,
    gradientTransform: "matrix(-1, 0, 0, 1, 246.4, -91.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#a1cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#afd3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c6e0fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#e5f3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebf6fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 939.3,
    y1: 317.9,
    x2: 888.07,
    y2: 406.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61c1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#77c7ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8ecded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9ed2ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#a8d4ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#abd5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#e6f3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebf6fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -365.74,
    y1: 319.87,
    x2: -69.97,
    y2: 319.87,
    gradientTransform: "translate(507.7 -155.87) rotate(-27.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebf6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d6eafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#a1cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -626.62,
    y1: 849.31,
    x2: -525.25,
    y2: 849.31,
    gradientTransform: "matrix(0.44, -0.06, 0.04, 0.36, 842.89, -148.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -618.66,
    y1: 410.74,
    x2: -564.16,
    y2: 430.62,
    gradientTransform: "matrix(0.66, -0.15, 0.21, 0.92, 1043.08, -112.11)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -297.78,
    y1: 271.03,
    x2: -242.16,
    y2: 271.03,
    gradientTransform: "matrix(-1, 0, 0, 1, 679.22, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2e3242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23486f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -294.39,
    cy: 289.67,
    r: 17.05,
    gradientTransform: "matrix(-0.94, 0, 0, 0.95, 671.88, 39.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c69c6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -243.13,
    y1: 377.01,
    x2: -243.13,
    y2: 377.01,
    gradientTransform: "matrix(-1, 0, 0, 1, 679.22, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -216.23,
    y1: 375.21,
    x2: -216.23,
    y2: 375.21,
    gradientTransform: "matrix(-1, 0, 0, 1, 679.22, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -406.32,
    y1: 337.86,
    x2: -353.5,
    y2: 429.33,
    gradientTransform: "matrix(-0.83, 0, 0, 1, 631.31, 0.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 975.92,
    y1: 309.62,
    x2: 912,
    y2: 443.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -200.09,
    y1: 366.7,
    x2: -187.02,
    y2: 389.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 887.06,
    y1: 353.21,
    x2: 858.43,
    y2: 402.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -288.7,
    y1: 254.02,
    x2: -238.08,
    y2: 254.02,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 149.49,
    y1: -138.51,
    x2: 171.44,
    y2: -100.49,
    gradientTransform: "matrix(-0.03, -1, -1, 0.03, 401.72, 426.42)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 983.36,
    y1: 372.58,
    x2: 914.99,
    y2: 335.79,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 233.01,
    y1: -150.13,
    x2: 265.86,
    y2: -93.23,
    gradientTransform: "matrix(-0.07, -1, -1, 0.07, 362.08, 537.58)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 940.61,
    y1: 388.52,
    x2: 859.83,
    y2: 349.19,
    xlinkHref: "#linear-gradient-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M872.81,631.19c-4.86,4.92-7.29,7.37-6.45,9.37,2,4.76,19.76,5.72,31.53-1.57,2.91-1.8,8-5,7.51-9.54-.52-4.82-7-9.37-12.59-10.18C885.64,618.23,880.46,623.46,872.81,631.19Z",
    transform: "translate(-432.82 -91.71)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 521.2,
    y: 133.11,
    width: 360.14,
    height: 517.26,
    rx: 33.97,
    transform: "translate(969.99 691.27) rotate(179.96)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 537.61,
    y: 144.34,
    width: 348.28,
    height: 499.91,
    rx: 24.34,
    transform: "translate(990.97 696.37) rotate(179.96)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 608.45,
    y: 344.19,
    width: 221.19,
    height: 17.56,
    rx: 8.78,
    transform: "translate(1005.52 613.72) rotate(179.96)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 609.32,
    y: 393.09,
    width: 221.19,
    height: 17.56,
    rx: 8.78,
    transform: "translate(1007.29 711.52) rotate(179.96)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 609.35,
    y: 432.76,
    width: 221.19,
    height: 17.56,
    rx: 8.78,
    transform: "translate(1007.38 790.85) rotate(179.96)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 609.37,
    y: 472.42,
    width: 221.19,
    height: 17.56,
    rx: 8.78,
    transform: "translate(1007.46 870.18) rotate(179.96)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 615.13,
    y: 208.02,
    width: 104.08,
    height: 89.49,
    rx: 24.34,
    transform: "translate(901.69 413.34) rotate(179.96)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 215.98,
    y: 25.48,
    width: 104.55,
    height: 40.03,
    rx: 8.46
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 268.25,
    cy: 27.69,
    r: 27.18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 397.92,
    cy: 268.62,
    r: 10.76
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "462.77 302.48 450.65 292.49 492.26 234.77 504.37 244.76 462.77 302.48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M895.63,394.51c-4.11-3.32-8.26-6.68-12.36-10.07l-.15-.12.1-.31a85.4,85.4,0,0,1,3.23-8.64q1.78-4.19,3.82-8.21c2.7-5.36,5.65-10.54,8.79-15.59,1.58-2.51,3.18-5,4.86-7.46.83-1.22,1.67-2.45,2.53-3.65s1.7-2.44,2.64-3.58a34.27,34.27,0,0,1,6.59-6.22,30.51,30.51,0,0,1,4.14-2.5,23.11,23.11,0,0,1,5-1.87l.42-.1,0,0,12.11,10,.05.44a23.43,23.43,0,0,1,2.72,7.85,18.73,18.73,0,0,1,0,6.31,15.73,15.73,0,0,1-1.84,5.09,17.36,17.36,0,0,1-1.45,2.1l-1.55,2a158.87,158.87,0,0,1-13.22,14.87,133.61,133.61,0,0,1-13.72,11.91C903.85,390.11,899.55,393,895.63,394.51Zm-.08-.64c3-8.09,5.64-14.84,8.08-21.15s4.71-11.85,7.07-17a114.63,114.63,0,0,1,7.59-14l1.05-1.6a8.9,8.9,0,0,1,1.15-1.5,8.62,8.62,0,0,1,3.35-2.13,16.56,16.56,0,0,1,5.17-.9,34.84,34.84,0,0,1,7.92.63l.06.44-12.11-10,.46-.06a23.25,23.25,0,0,1-.19,5.34,31,31,0,0,1-1.06,4.72,34.27,34.27,0,0,1-3.82,8.21c-.79,1.26-1.69,2.44-2.56,3.64s-1.77,2.38-2.67,3.56c-1.78,2.37-3.66,4.67-5.54,7-3.79,4.57-7.77,9-12,13.27-2.12,2.13-4.3,4.21-6.58,6.22a85.46,85.46,0,0,1-7.17,5.79l-.06-.43C887.66,387.23,891.59,390.53,895.55,393.87Z",
    transform: "translate(-432.82 -91.71)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "608 209.88 324.27 282.79 317.55 247.17 601.27 174.26 608 209.88"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "647.05 183.51 606.66 211.57 601.32 174.35 647.05 183.51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M756.69,375.27l-31.62,8.33a.49.49,0,0,1-.59-.4l-7-35.78a.55.55,0,0,1,.38-.65l31.62-8.33a.48.48,0,0,1,.59.4l7,35.78A.56.56,0,0,1,756.69,375.27Z",
    transform: "translate(-432.82 -91.71)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "533.97 525.74 512.58 526.88 504.37 350.09 525.76 348.95 533.97 525.74"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M967.07,617.7c-7.18.44-14.43.88-21.64,1.26h-.32l-.08-.37c-1.49-7.31-2.73-14.64-3.84-22s-2.11-14.66-3-22c-1.79-14.68-3.2-29.38-4.35-44.09s-2-29.44-2.58-44.17a173.72,173.72,0,0,1,.94-22.19c.41-3.71,1-7.43,1.69-11.16a80.75,80.75,0,0,1,2.92-11.2l.13-.38h.22l21.39-1.14h0l.38.35a43.42,43.42,0,0,1,8.42,11.06,57.15,57.15,0,0,1,4.79,11.62,64.73,64.73,0,0,1,2.27,11.81c.2,2,.29,3.93.34,5.89l.19,5.87c.42,15.66.38,31.27-.13,46.52s-1.44,30.14-2.73,44.33c-.33,3.54-.65,7.06-1,10.5l-.56,5.15-.6,5.06C969.06,605.13,968.21,611.65,967.07,617.7Zm-.55-.5c-1.82-8.69-3.36-16.9-4.88-25l-1.12-6-1.07-5.89c-.73-3.93-1.39-7.78-2.07-11.6-2.66-15.27-5-29.85-6.84-44.07s-3.28-28.06-4.23-41.87l-.33-5.18c-.12-1.72-.2-3.44-.17-5.16a47.6,47.6,0,0,1,1.25-10.28,49.88,49.88,0,0,1,11.15-21.52l.39.35-21.39,1.14.36-.39a81.05,81.05,0,0,1,3.94,10.89c1.07,3.64,2,7.29,2.72,10.95a173.73,173.73,0,0,1,3,22c.83,14.73,1.31,29.47,1.53,44.22s.18,29.52-.24,44.31q-.3,11.08-.94,22.19c-.42,7.4-1,14.81-1.79,22.23l-.39-.36C952.43,617.83,959.45,617.51,966.52,617.2Z",
    transform: "translate(-432.82 -91.71)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M921.39,267c.23,15.44,11.7,33.27,27.64,33.35,16.59.08,29.31-19.14,27.86-34.55a28.76,28.76,0,0,0-8.08-16.88c-5.75-5.76-12.13-6.2-21.52-6.83-8.59-.59-12.88-.88-17.16,2.41C921.34,251.26,921.38,266.27,921.39,267Z",
    transform: "translate(-432.82 -91.71)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M932.06,330.52l34.26-.34a30.55,30.55,0,0,1-7.44-9.75,24.18,24.18,0,0,1-2.17-6.43,41.46,41.46,0,0,1-.5-6c-.08-1.71-.09-3.44-.1-4.49,0-1.31,0-2.41,0-3.2H941.18c.06.78.14,1.88.2,3.2.07,1.59.14,3.1.1,4.7a32.54,32.54,0,0,1-.6,5.54,29.38,29.38,0,0,1-2.81,7.3A57.86,57.86,0,0,1,932.06,330.52Z",
    transform: "translate(-432.82 -91.71)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M922.36,377",
    transform: "translate(-432.82 -91.71)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M895.45,375.21",
    transform: "translate(-432.82 -91.71)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "455.03 513.09 475.99 517.77 509.79 344.5 488.83 339.82 455.03 513.09"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M888.09,604.65l20.79,4.56-.34.22c1.14-14.77,2.88-29.42,4.88-44s4.27-29.14,6.74-43.65,5.13-29,8.06-43.39a220.06,220.06,0,0,1,5.7-21.37q1.68-5.29,3.74-10.51a100,100,0,0,1,4.67-10.33l.22.33-21-4.68.34-.22a49.61,49.61,0,0,1,3.82,11.7,60,60,0,0,1,1.16,10.87,64.9,64.9,0,0,1-.71,10.46c-.53,3.45-1.33,6.87-2,10.31-2.91,13.72-6.16,27.43-9.81,41.36s-7.65,28.06-12,42.69S893.36,588.63,888.09,604.65Zm-.47.31c.36-12.87,1.41-26.74,2.65-41s2.91-29,4.88-43.94,4.35-30.13,7.08-45.28c.71-3.79,1.31-7.58,2.2-11.35a80.26,80.26,0,0,1,3.51-11.21,68.16,68.16,0,0,1,5.38-10.78,46.53,46.53,0,0,1,8-9.95l.27-.24h.07l21,4.69.19,0,0,.29a102.88,102.88,0,0,1,.45,11.33c0,3.73-.2,7.45-.48,11.14-.54,7.39-1.49,14.7-2.75,21.95q-4.07,21.69-8.84,43.24t-10.16,43c-3.64,14.28-7.53,28.51-12,42.63l-.09.27-.25,0Z",
    transform: "translate(-432.82 -91.71)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "525.16 375.2 485.55 371.48 489.71 317.04 529.33 320.76 525.16 375.2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M964.31,474.4c-3.73.09-7.47.25-11.27.44l-11.6.62c-2,.12-4,.14-5.94.38s-4,.64-6,1a32.13,32.13,0,0,1-6.2.65,24.49,24.49,0,0,1-6.2-.88l-14.93-4,2.76-10.43a71.89,71.89,0,0,1,5.13-13.29c2.14-4.4,4.65-8.77,6.71-13.18a53.2,53.2,0,0,0,4.45-13.35,57.44,57.44,0,0,0,.78-6.78l.5-6.81v0h0c3.3.29,6.6.62,9.91.86l9.91.78c3.31.24,6.61.54,9.91.86a59.32,59.32,0,0,0,10,.18l.87-.05.09,1.19a72.28,72.28,0,0,0,3.08,14.95l2.62,8.6c.87,3,1.7,6.13,2.43,9.37a78.83,78.83,0,0,1,2,19.4c0,1.56-.12,3.11-.25,4.63a13.35,13.35,0,0,1-.75,4.22,3.61,3.61,0,0,1-2.67,2.14,5.94,5.94,0,0,1-2.23-.1l-.68-.19-.76-.3A12.41,12.41,0,0,1,964.31,474.4Zm-12.64-15-1.56-2.56-1.3-2.19c-.78-1.34-1.4-2.46-2-3.51a29.14,29.14,0,0,1-2.15-4.67,6.27,6.27,0,0,1-.23-2.58,18.64,18.64,0,0,1,.27-2.17,17.19,17.19,0,0,1,4.07-7.82c1.08-1.3,2.26-2.71,3.48-4.24.6-.77,1.25-1.56,1.87-2.39s1.22-1.71,1.78-2.62a40.42,40.42,0,0,0,5.17-12.27l1,1.14a60.31,60.31,0,0,0-9.83-1.68c-3.31-.3-6.61-.62-9.9-1l-9.89-1.08c-3.3-.38-6.6-.67-9.9-1l0,0-.54,6.8a55.32,55.32,0,0,0-.26,6.82,53.63,53.63,0,0,0,2.36,13.87c1.37,4.67,3.19,9.37,4.64,14.05a72.71,72.71,0,0,1,3,13.92l-12.17-14.44a8.74,8.74,0,0,1,3.71.05,15.71,15.71,0,0,1,3.7,1.58c1.27.66,2.59,1.39,3.92,1.92s2.63.88,4,1.31c2.67.83,5.4,1.66,8.2,2.47S948.79,458.7,951.67,459.41Z",
    transform: "translate(-432.82 -91.71)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M954.21,329.17c-3,5.25-8.16,8.43-13.33,8.08a12.54,12.54,0,0,1-6.6-2.53,12.26,12.26,0,0,0-5.47,4.09,13.27,13.27,0,0,0-2.16,8.16c.27,17-7.27,63.25-7.52,64.79-.46,2.78-1.23,7.21-2.42,12.68a.9.9,0,0,0,.2.5.62.62,0,0,0,.47.2l48.67-.27a.68.68,0,0,0,.66-.7c-.07-6.61-.42-16.21-1.29-18.81-2.56-7.64-4.71-22.42-3.11-53.7-.46-1.74-1.12-4.42-1.75-7.76-.54-2.8-.61-3.74-.9-5A20.83,20.83,0,0,0,954.21,329.17Z",
    transform: "translate(-432.82 -91.71)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M955.32,338.66a7.56,7.56,0,0,0,4.62-1.52,7.31,7.31,0,0,0,1.6-1.66l.06-.09,0,0,0,.05-.08.12-.15.23c-.42.61-.86,1.22-1.33,1.81a26.62,26.62,0,0,1-3.13,3.35,25,25,0,0,1-8.36,5,22.06,22.06,0,0,1-10.67,1,23.26,23.26,0,0,1-9.71-3.94l10,1.3c-.61.36-.73.69-.61.74s.26,0,.45.35c.1.19.23.41.41.79a2.21,2.21,0,0,1,.14.42c0,.21.09.55.14.81l.28,1.71.27,1.72c.07.53.14,1.07.2,1.61.13,1.07.23,2.16.28,3.22a31.7,31.7,0,0,1-.34,6.18c-.32,2-.8,4-1.31,6a103.8,103.8,0,0,1-3.75,11.6c-2.86,7.62-6.64,15-9.86,22.45-.82,1.85-1.56,3.72-2.3,5.58s-1.36,3.75-2.05,5.62a93.47,93.47,0,0,0-3.29,11.33v0a.67.67,0,0,0,.51.68h2.89l3.87,0,7.73-.05,15.47-.08,15.46-.09h2.9c.31,0,.68.06.91-.21s.2-.6.19-.92v-1l0-1.94c-.06-2.57-.15-5.15-.3-7.72-.08-1.29-.17-2.58-.3-3.86-.06-.64-.13-1.28-.22-1.92-.06-.31-.09-.64-.16-1a1.59,1.59,0,0,0-.14-.47,1.22,1.22,0,0,0-.49-.34,2.35,2.35,0,0,1-.54-.33,3,3,0,0,1-.31-.42c-.18-.29-.38-.58-.56-.87-.34-.59-.72-1.18-1-1.79-.67-1.21-1.33-2.44-2-3.69-1.24-2.5-2.45-5.05-3.56-7.65s-2.18-5.22-3.18-7.86c-2-5.29-3.86-10.66-5.35-16a126.9,126.9,0,0,1-3.33-16.15l.54,5.24c-.91-2.16-1.77-4.37-2.58-6.6-.41-1.12-.81-2.22-1.14-3.38-.17-.58-.34-1.18-.49-1.74a7,7,0,0,0-.37-1.15c-.08-.11-.09,0,0,0a.33.33,0,0,0,.24,0,3.12,3.12,0,0,0,1.19-.74,8.64,8.64,0,0,0,.9-.91c.18-.19.31-.38.5-.61a8.11,8.11,0,0,0,.54-.73c.41-.54.78-1.13,1.25-1.88l.35-.57.18-.29a10.13,10.13,0,0,0,1.53,1,9.44,9.44,0,0,0,4,1A6.85,6.85,0,0,0,955.32,338.66Zm-2.21-19a9.46,9.46,0,0,1,4.06-.23,12.67,12.67,0,0,1,4.49,1.61,15.76,15.76,0,0,1,1.78,1.27h1.26a12.58,12.58,0,0,1,3.14.5c.48.15.95.31,1.43.5s.9.42,1.35.66a13.06,13.06,0,0,1,2.45,1.7,15.91,15.91,0,0,1,3.69,4.8,18.13,18.13,0,0,1,1.15,2.89,18.47,18.47,0,0,1,.61,3c.09.88.11,1.4.12,1.85l0,1.26c0,.83.07,1.7.11,2.56.09,1.73.12,3.48.11,5.27l.54,5.24c-1.25,4.92-2.74,9.83-4.37,14.76s-3.38,9.88-4.9,14.89a99.86,99.86,0,0,0-3.58,15.23c-.17,1.29-.32,2.59-.38,3.88-.05.66-.05,1.3-.07,2,0,.33,0,.65,0,1a1.54,1.54,0,0,1-.28,1.09,1.78,1.78,0,0,0-.23.59,1.29,1.29,0,0,0,.06.48c.07.31.1.64.16,1,.09.64.16,1.28.22,1.92.13,1.28.22,2.57.3,3.86.15,2.57.24,5.15.3,7.72l0,1.94v1c0,.32.07.68-.19.92s-.6.19-.91.21h-2.9l-15.46.09-15.47.08-7.73.05-3.87,0-1.93,0c-.32,0-.64,0-1,0a.75.75,0,0,1-.62-.71h0a80.37,80.37,0,0,0,.44-23.61c-.87-8-2.46-16.08-3.36-23.95-.5-3.94-.82-7.84-1-11.67-.06-.95-.09-1.91-.12-2.86s-.08-1.88-.05-2.82a31.26,31.26,0,0,1,.58-5.49c.17-.9.35-1.75.57-2.63l.65-2.52.31-1.23c.05-.22.1-.37.15-.65l.14-1a32.15,32.15,0,0,1,1-5,24.18,24.18,0,0,1,5.51-10.06,22.86,22.86,0,0,1,9-5.78l6.5-2.34,3.51,3.64a5.12,5.12,0,0,0,1,.81,1.38,1.38,0,0,0,1,.13,3.86,3.86,0,0,0,1.76-.87,6.14,6.14,0,0,0,1-.9,4,4,0,0,0,.43-.55l.06-.07,0,0h0l.1-.15a11.8,11.8,0,0,1,2-2.28A12.22,12.22,0,0,1,953.11,319.68Z",
    transform: "translate(-432.82 -91.71)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "408.68 283.35 410.18 275.65 471.22 289.28 469.72 296.98 408.68 283.35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M841.24,375.24c.45-2.63.93-5.31,1.45-7.95l0-.2.35,0a71.4,71.4,0,0,1,8.16-.67c2.69-.08,5.35-.06,8,.05a148.24,148.24,0,0,1,15.69,1.46c5.17.78,10.3,1.69,15.36,3a26.15,26.15,0,0,1,7.25,3.37,23.2,23.2,0,0,1,6.57,6.44l.25.37h0l-1.5,7.7-.39.26c-.47.62-1,1.32-1.45,1.87s-.94,1-1.41,1.52l-1.37,1.23c-.23.2-.47.42-.7.59l-.67.5a17.62,17.62,0,0,1-5.26,2.58,13,13,0,0,1-4.84.45,14.91,14.91,0,0,1-2.23-.44l-2.17-.57A124.85,124.85,0,0,1,865.69,391a99.4,99.4,0,0,1-14.29-7.41C847.26,380.92,843.56,378.21,841.24,375.24Zm.53-.36c7.85-.7,14.33-1.13,20.35-1.56s11.3-.63,16.23-.59a90.55,90.55,0,0,1,13.85,1.09l1.63.29a7.25,7.25,0,0,1,1.6.42,7,7,0,0,1,2.78,2.14,16.84,16.84,0,0,1,2.38,4.29l.27.71c.09.24.17.54.26.81l.53,1.65.5,1.95c.16.69.3,1.54.46,2.3l-.38.25,1.5-7.71.24.38a23.07,23.07,0,0,1-8.68,3,26.53,26.53,0,0,1-8,0c-5.12-1-10.15-2.34-15.16-3.84a147.49,147.49,0,0,1-14.82-5.35c-2.44-1-4.87-2.15-7.26-3.36a70.5,70.5,0,0,1-7.1-4.08l.38-.25C842.84,369.91,842.32,372.38,841.77,374.88Z",
    transform: "translate(-432.82 -91.71)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M920.71,278.74c.18,6.62.51,18.73,8.92,25.47a20.11,20.11,0,0,0,10.71,4.23,21,21,0,0,0,14.28-4.14,22.69,22.69,0,0,0,6.06-6.95c2-3.51,2.13-5.93,3.66-15.21,1.92-11.7,2.24-11.21,2-12.5-1.66-8.72-12.91-14.33-21.77-15.34-3-.34-14.07-1.6-20.25,6.19C920.35,265.48,920.51,271.51,920.71,278.74Z",
    transform: "translate(-432.82 -91.71)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M917.35,252.45c-.59,4.76,4.62,9,5.23,9.44,3.51,2.76,6.38,2.38,19.94,1.79,11-.48,13.52-.42,17.44-2.6,1.09-.61,8.44-4.81,7.93-9-.33-2.83-4-4.44-7.35-5.69-5.24-1.94-11-2.09-19.6-2.3-7.82-.2-11.73-.3-15.62.81C923,245.52,917.91,248,917.35,252.45Z",
    transform: "translate(-432.82 -91.71)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M975.36,642.3c-3,5.77-9.25,7.24-14.18,8.41-5.37,1.27-18,2.88-20-2.83s7.64-14.73,12.7-18.47c3.12-2.3,10.46-7.72,16.66-5.13a10.31,10.31,0,0,1,4.9,4.65A14.57,14.57,0,0,1,975.36,642.3Z",
    transform: "translate(-432.82 -91.71)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "482.97 278.2 493.32 290.01 549.77 246.7 539.42 234.89 482.97 278.2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M916.11,369.94c3.46,3.86,6.88,7.68,10.28,11.56l-.44,0a83.76,83.76,0,0,1,5.58-7.34q2.91-3.51,6-6.76c4.12-4.37,8.44-8.48,12.91-12.4,2.23-2,4.48-3.9,6.79-5.75q1.72-1.41,3.48-2.77c1.17-.91,2.33-1.85,3.56-2.67a33.88,33.88,0,0,1,8.09-4.06,29.8,29.8,0,0,1,4.69-1.2,23.24,23.24,0,0,1,5.33-.36l0,.47L972,326.81l.44,0a35.38,35.38,0,0,1,.87,7.9,16.48,16.48,0,0,1-.75,5.19,8.57,8.57,0,0,1-2,3.42,9.52,9.52,0,0,1-1.48,1.19l-1.56,1.1a113.57,113.57,0,0,1-13.76,8c-5,2.51-10.54,4.95-16.72,7.57S924.11,366.68,916.11,369.94Zm-.64-.06c1.41-4,4.16-8.35,7.32-12.95a132.07,132.07,0,0,1,11.51-14.08,157.28,157.28,0,0,1,14.46-13.66l2-1.6a16.27,16.27,0,0,1,2.06-1.51,15.63,15.63,0,0,1,5-2,18.67,18.67,0,0,1,6.31-.22,23.63,23.63,0,0,1,7.93,2.48l.43.05,10.36,11.8,0,.05-.09.42a23.29,23.29,0,0,1-1.72,5.06,31.53,31.53,0,0,1-2.38,4.21,33.46,33.46,0,0,1-6,6.76c-1.11,1-2.31,1.86-3.49,2.75s-2.38,1.78-3.58,2.65c-2.39,1.75-4.85,3.42-7.32,5.07-4.94,3.29-10,6.4-15.31,9.26q-4,2.15-8.09,4.07a87.14,87.14,0,0,1-8.54,3.48l-.31.1-.13-.14C922.4,377.93,918.91,373.89,915.47,369.88Z",
    transform: "translate(-432.82 -91.71)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "437.11 264.31 433.88 271.05 494.71 296.09 497.93 289.35 437.11 264.31"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M870,356.31c-1,2.22-2,4.4-3.06,6.58l-.16-.42a77.86,77.86,0,0,1,8.49,1q4.17.68,8.22,1.62,8.13,1.88,15.94,4.49c5.2,1.76,10.36,3.64,15.37,5.87a29.8,29.8,0,0,1,7,4.65,24.94,24.94,0,0,1,5.83,7.43l-.4.16,3.23-6.74.16.41c-.58.5-1.18,1.09-1.71,1.52l-1.55,1.23-1.41,1c-.23.16-.47.34-.69.48l-.65.39a16.88,16.88,0,0,1-4.57,1.93,8.05,8.05,0,0,1-3.72,0,7.86,7.86,0,0,1-1.65-.62l-1.61-.74a103.79,103.79,0,0,1-12.86-7.29c-4.36-2.86-8.85-6.15-13.78-9.93S876.23,361.37,870,356.31Zm-.22-.58c3.95-.89,8.81-.81,14-.46a115.34,115.34,0,0,1,16.64,2.59A142.71,142.71,0,0,1,918,363.09l2.19.82a15.07,15.07,0,0,1,2.15.94,14.09,14.09,0,0,1,3.88,3.15,18.08,18.08,0,0,1,3,5.06l.3.78c.1.27.18.58.26.87l.49,1.75c.13.65.24,1.35.35,2s.14,1.54.19,2.3l.17.42-3.23,6.74v0l-.39.12a24.85,24.85,0,0,1-9.37,1.18,29.61,29.61,0,0,1-8.23-1.61c-5.13-1.95-10.12-4.23-15-6.65s-9.75-5.1-14.48-8c-2.36-1.46-4.69-3-7-4.64a80.31,80.31,0,0,1-6.72-5.29l-.25-.22.09-.19C867.53,360.31,868.68,358,869.82,355.73Z",
    transform: "translate(-432.82 -91.71)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 423.91,
    cy: 249.39,
    r: 10.76
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_04",
    "data-name": "icon 04"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M462.25,571.79H444.31a6,6,0,0,1-6-6V547.86a6,6,0,0,1,6-6h17.94l6.34-15.3L455.9,513.89a6,6,0,0,1,0-8.46l12.69-12.69a6,6,0,0,1,8.46,0l12.69,12.69L505,499.1v-18a6,6,0,0,1,6-6H529a6,6,0,0,1,6,6v18l15.3,6.33,12.69-12.69a6,6,0,0,1,8.46,0l12.69,12.69a6,6,0,0,1,0,8.46l-12.69,12.69,6.34,15.3h17.94a6,6,0,0,1,6,6v17.95a6,6,0,0,1-6,6H577.73l-6.34,15.29,12.69,12.69a6,6,0,0,1,0,8.46l-12.69,12.7a6,6,0,0,1-8.46,0l-12.69-12.7-15.3,6.34v17.95a6,6,0,0,1-6,6H511a6,6,0,0,1-6-6V614.57l-15.29-6.34-12.69,12.7a6,6,0,0,1-8.46,0l-12.69-12.7a6,6,0,0,1,0-8.46l12.69-12.69Z",
    transform: "translate(-432.82 -91.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M471.07,586.41H453.13a6,6,0,0,1-6-6V562.48a6,6,0,0,1,6-6h17.94l6.34-15.3-12.69-12.69a6,6,0,0,1,0-8.46l12.69-12.69a6,6,0,0,1,8.46,0l12.69,12.69,15.3-6.33v-18a6,6,0,0,1,6-6h17.94a6,6,0,0,1,6,6v18l15.29,6.33,12.69-12.69a6,6,0,0,1,8.46,0l12.69,12.69a6,6,0,0,1,0,8.46L580.21,541.2l6.34,15.3h17.94a6,6,0,0,1,6,6v17.95a6,6,0,0,1-6,6H586.55l-6.34,15.29,12.69,12.69a6,6,0,0,1,0,8.47l-12.69,12.69a6,6,0,0,1-8.46,0l-12.69-12.69-15.29,6.33v17.95a6,6,0,0,1-6,6H519.84a6,6,0,0,1-6-6V629.19l-15.3-6.33-12.69,12.69a6,6,0,0,1-8.46,0l-12.69-12.69a6,6,0,0,1,0-8.47l12.69-12.69Z",
    transform: "translate(-432.82 -91.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 95.99,
    cy: 479.75,
    r: 33.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 95.99,
    cy: 479.75,
    r: 8.82
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditarperfil);
export default __webpack_public_path__ + "static/media/Editarperfil.aaba96320fb75c1d90c38466339f48e1.svg";
export { ForwardRef as ReactComponent };